import { render, staticRenderFns } from "./ShowCarousel.vue?vue&type=template&id=9fab9f90&scoped=true&"
import script from "./ShowCarousel.vue?vue&type=script&lang=js&"
export * from "./ShowCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ShowCarousel.vue?vue&type=style&index=0&id=9fab9f90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fab9f90",
  null
  
)

export default component.exports